import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { TOKEN_KEY, clearSession } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = anonymous

  const refresh = useCallback(async () => {
    if (!localStorage.getItem(TOKEN_KEY)) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      clearSession();
      setUser(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const applyAuth = (data) => {
    localStorage.setItem(TOKEN_KEY, data.token);
    localStorage.setItem("smw_last_active", String(Date.now()));
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => applyAuth((await api.post("/auth/login", { email, password })).data);
  const register = async (payload) => applyAuth((await api.post("/auth/register", payload)).data);
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    clearSession();
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, register, logout, refresh, setUser }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
